import React from "react";
import { connect } from 'react-redux'

import store from '../../../redux/store';
import { client } from '../../../services/client';
import { selectPanel, selectCharacter, selectActiveCharacterOrder, selectCharacterPanel } from '../../../redux/selectors';
import { disableKeyboardMovement, enableKeyboardMovement, showHelp } from '../../../redux/actions/keyboard-shortcuts.actions';
import { updateCharacterPanelAsync, addCharacterPanelAsync } from '../../../redux/actions/character-panel.actions';
import { biomeMap } from './biome-map';
import { seasonMap } from './season-map';
import { getMinutes } from 'date-fns';

import './Location.css';

class Location extends React.Component {
    state = {
        text: '',
        isInitialised: false
    }
    constructor() {
        super();
    }

    handleInput = event => {
        this.setState({ text: event.target.value.slice(0, 20) });
    }

    disableMovement = () => {
        store.dispatch(disableKeyboardMovement());
    }

    saveAndEnableMovement = () => {
        store.dispatch(enableKeyboardMovement());

        if (this.props.characterPanel) {
            store.dispatch(updateCharacterPanelAsync({
                _id: this.props.characterPanel._id,
                locationName: this.state.text
            }));
        } else {
            store.dispatch(addCharacterPanelAsync({
                locationName: this.state.text,
                userId: this.props.character.userId,
                panelId: this.props.panel.id,
                z: this.props.character.z
            }));
        }
    }

    getTimeOfDay() {
        const now = new Date().getTime();

        const minutesPast = getMinutes(now);

        if (minutesPast < 5) {
            return 'Late Night';
        }

        if (minutesPast < 10) {
            return 'Dawn';
        }

        if (minutesPast < 15) {
            return 'Early Day';
        }

        if (minutesPast < 20) {
            return 'Late Day';
        }

        if (minutesPast < 25) {
            return 'Dusk';
        }

        if (minutesPast < 30) {
            return 'Early Night';
        }

        if (minutesPast < 35) {
            return 'Late Night';
        }

        if (minutesPast < 40) {
            return 'Dawn';
        }

        if (minutesPast < 45) {
            return 'Early Day';
        }

        if (minutesPast < 50) {
            return 'Late Day';
        }

        if (minutesPast < 55) {
            return 'Dusk';
        }

        if (minutesPast < 60) {
            return 'Early Night';
        }

        return 'ERROR';
    }

    static getDerivedStateFromProps(nextProps, state) {
        if (nextProps.panel?.id !== state.panelId) {
            state.panelId = nextProps.panel?.id;
            state.text = nextProps.characterPanel?.locationName || 'Unknown Location';
        }

        if (nextProps.characterPanel?.locationName !== state.text) {
            state.text = nextProps.characterPanel?.locationName || 'Unknown Location';
        }

        return { ...state };
    }

    render() {
        const orderCostString = this.props.activeOrder?.waitCost ? (<span>{this.props.activeOrder.waitCount}/{this.props.activeOrder.waitCost}</span>) : (<></>);

        let activityString = this.props.activeOrder?.type
        if (this.props.activeOrder?.type === 'idle') {
            activityString = this.props.activeOrder?.data?.itemText
        }

        if (this.props.activeOrder?.type === 'gather') {
            activityString = `${this.props.activeOrder?.data?.resources}`
        }
        return (
            <div className="location">
                {this.props.activeOrder ? (<span className={this.props.activeOrder?.type === 'idle' ? "idle": "active-order"}>{activityString} {orderCostString}</span>) : (<span className="active-order">Idle</span>) }
                {this.props.character.healthPoints <= 0 ? (<span className="help-hint">Press b to learn about Near-Death State</span>) : (<span className="help-hint">Press ? or / for Help</span>)}
                <span className="location-input">{this.state.text}</span>
                <span className="season">{this.getTimeOfDay()}</span>
                <span className="biome">{this.props.panel.elevation >= 150 ? biomeMap['MOUNTAIN'] : biomeMap[this.props.panel.biome]}</span>
            </div>
        )
    }
}

const mapToStateProps = state => {
    const panel = selectPanel(state);
    const character = selectCharacter(state);
    const activeOrder = selectActiveCharacterOrder(state, character._id);
    const characterPanel = selectCharacterPanel(state, character.panelId);

    return { panel, character, activeOrder, characterPanel }
}

export default connect(
    mapToStateProps,
    {
        updateCharacterPanelAsync,
        addCharacterPanelAsync
    }
)(Location);